import { observer } from 'mobx-react';
import _ from 'lodash';

import { StudentApi } from '../../util/api/StudentApi';
import { ApiMixin } from './ApiMixin';
import { Alert } from "../Alert"

//Returns the student object, plus some helper functions  
class Student {

    id = null;
    tuid = null;

    awardAmount = null;
    balance = null

    firstName = null;
    middleName = null;
    lastName = null;
    suffix = null;
    email = null;

    accountIds = [];


    // constructor(student = {}, shouldParseValues = false) {

    //     //Adds any default values passed by the developer 
    //     _.defaults(this, student);

    //     //Add the API functions to this object
    //     ApiMixin(this, StudentApi);
    // }
    constructor(student = {}, shouldParseValues = false) {

        _.assign(this, _.pick(student, [
            "id",
            "tuid",
            "awardAmount",
            "balance",
            "firstName",
            "middleName",
            "lastName",
            "suffix",
            "email",
            "accountIds"
        ]));

        ApiMixin(this, StudentApi);
    }
    mutate(student = {}) {

        //This takes all matching keys from the student and assigns them to this object

        _.assign(this, _.pick(student, _.keys(this)));

    }

    //Gets the student's full name (lack of middle name can cause issues.) 
    get name() {
        if (this.middleName) {
            return `${this.firstName} ${this.middleName} ${this.lastName}`
        }
        else {
            return `${this.firstName} ${this.lastName}`
        }
    }

    //Saves/updates object to the api, shows errors or updates state. 
    async save(appStore) {

        const api = ApiMixin(StudentApi);

        let response = await api.save(this);
        console.log(response)
        //If there are errors, we iterate over them and display them.
        //Then we return false, in case the parent needs to know we failed.

        if (response.errors.length > 0) {
            _.forEach(response.errors, (error) => {
                appStore.addAlert(error);
            });

            return response;
        }

        //If this already exists in the store, get it we'll be updating it both on api and in store.
        //We also need to check if it is the most recent payperiod (think about another way to do this.)
        let newStudentObject = null;

        if (this.id) {

            newStudentObject = appStore.students.getById(this.id);

            console.log(newStudentObject)

            //Diff any changes between store and response.
            newStudentObject.mutate(this);

        }
        //If not, we're going to save it to the API, and to push it to the store ;
        else {

            newStudentObject = new Student(response.data);

            console.log(newStudentObject)

            appStore.addItem({ type: "student", data: newStudentObject });
        }

        //Success alert
        let successAlert = new Alert("Successfully saved", "Successfully saved student.", "sucess");
        appStore.addAlert(successAlert);

        //Return the new timesheet object  
        return newStudentObject;
    }
}


export default Student;